/**
 * @description 课程模块
 */
import {
  getCourses,
  getCourseRank,
  getCourseBase,
  getCourseDetail,
  updateCourseStats,
  getCourseUpdateStats,
  setCourseFilter,
  getActStat,
  getActDetail,
  getActStudent,
  getCourseSituationRank,
  getSituationChart,
  getStudentDoc,
  getStudentDocDetail,
  getCourseSuggest,
  getAccessWarn,
  getAssignWarn,
  getQuizWarn,
  getForumWarn,
  getGradeWarn,
  getCourseGroup,
  getCourseJoinType,
} from '@/api/course'

const state = () => ({
  courseRank: {},
  courseInfo: {},
})

const getters = {}
// 同步方法写在这里--对应commit
const mutations = {
  setCourseRank(state, data) {
    state.courseRank = data
  },
  setCourseInfo(state, data) {
    state.courseInfo = data
  },
}
// 异步请求写在这里--对应dispatch
const actions = {
  // 获取课程数据
  getCourses({}, data) {
    return new Promise((resolve, reject) => {
      getCourses(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取课程排行数据
  getCourseRank({}, data) {
    return new Promise((resolve, reject) => {
      getCourseRank(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取课程基本情况
  getCourseBase({}, data) {
    return new Promise((resolve, reject) => {
      getCourseBase(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取课程详细信息
  getCourseDetail({}, data) {
    return new Promise((resolve, reject) => {
      getCourseDetail(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 更新课程统计
  updateCourseStats({}, data) {
    return new Promise((resolve, reject) => {
      updateCourseStats(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 更新课程统计
  getCourseUpdateStats({}, data) {
    return new Promise((resolve, reject) => {
      getCourseUpdateStats(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 课程筛选设置
  setCourseFilter({}, data) {
    return new Promise((resolve, reject) => {
      setCourseFilter(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取教学统计数据
  getActStat({}, data) {
    return new Promise((resolve, reject) => {
      getActStat(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取教学活动详情
  getActDetail({}, data) {
    return new Promise((resolve, reject) => {
      getActDetail(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取教学活动学生详情
  getActStudent({}, data) {
    return new Promise((resolve, reject) => {
      getActStudent(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取课程访问/任务完成排行
  getCourseSituationRank({}, data) {
    return new Promise((resolve, reject) => {
      getCourseSituationRank(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取学情分析图表
  getSituationChart({}, data) {
    return new Promise((resolve, reject) => {
      getSituationChart(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取学员档案列表
  getStudentDoc({}, data) {
    return new Promise((resolve, reject) => {
      getStudentDoc(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取学员档案详情
  getStudentDocDetail({}, data) {
    return new Promise((resolve, reject) => {
      getStudentDocDetail(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取课程建议
  getCourseSuggest({}, data) {
    return new Promise((resolve, reject) => {
      getCourseSuggest(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取未访问课程列表
  getAccessWarn({}, data) {
    return new Promise((resolve, reject) => {
      getAccessWarn(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取作业完成异常列表
  getAssignWarn({}, data) {
    return new Promise((resolve, reject) => {
      getAssignWarn(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取测验完成异常列表
  getQuizWarn({}, data) {
    return new Promise((resolve, reject) => {
      getQuizWarn(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取讨论参与异常列表
  getForumWarn({}, data) {
    return new Promise((resolve, reject) => {
      getForumWarn(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取不及格预警列表
  getGradeWarn({}, data) {
    return new Promise((resolve, reject) => {
      getGradeWarn(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取课程小组
  getCourseGroup({}, data) {
    return new Promise((resolve, reject) => {
      getCourseGroup(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取课程选课方式列表
  getCourseJoinType({}, data) {
    return new Promise((resolve, reject) => {
      getCourseJoinType(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}

export default { state, getters, mutations, actions }
